import {
  Badge,
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  createStyles,
  makeStyles,
} from "@material-ui/core";
import { withRouter, Link, useLocation } from "react-router-dom";
import { screenRoutes } from "../../routers/ScreensRoutes";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import React from "react";
import {
  IconChevronDown,
  IconChevronUp,
  IconPointFilled,
} from "@tabler/icons-react";
import { setMenuOpen, setMenuSelected } from "../../slices/commonSlice";

const useStyles = makeStyles((theme) =>
  createStyles({
    icon: {
      width: "36px",
      minWidth: "36px",
      display: "flex",
      justifyContent: "center",
      "& svg": {
        height: 20,
      },
    },
    root: {
      marginBottom: 5,
      "& .MuiListItem-root": {
        borderRadius: "8px",
        padding: "8px 4px",
        color: theme.palette.common.black,
        "& .MuiTypography-root": {
          marginLeft: 6,
          fontSize: 14,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
      },
      "& .MuiListItem-root:hover": {
        backgroundColor: "#EEF1FF",
      },
      "& .Mui-selected , .Mui-selected:hover": {
        backgroundColor: "#EEF1FF",
        "& .MuiTypography-root": {
          fontWeight: 700,
          color: theme.palette.primary.main,
        },
        "& .MuiListItemIcon-root": {
          color: theme.palette.primary.main,
        },
      },
    },
    rootNested: {
      paddingLeft: theme.spacing(2),
      "& .SubItem": {
        borderRadius: 0,
        paddingBottom: 4,
      },
      "& .Mui-selected": {},
    },
  })
);

interface propsMenuItem {
  item: any;
  pros: any;
}

const MenuItem = ({ item }: propsMenuItem) => {
  const classes = useStyles();
  const { menuSelected, drawerOpen } = useAppSelector((state) => state.common);
  const [showChildren, setShowChildren] = React.useState(
    localStorage.getItem("menuOpen") === item.path
  );
  const [showPopOver, setshowPopOver] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const dispatch = useAppDispatch();
  const location = useLocation();

  const handleItemPath = (_item: any) => {
    localStorage.setItem("lastPath", _item.path);
    dispatch(setMenuSelected(_item.path));
  };

  const setMenuOpenState = () => {
    setShowChildren(!showChildren);
    if (showChildren === true) {
      localStorage.removeItem("menuOpen");
    } else {
      localStorage.setItem("menuOpen", item.path);
    }
    dispatch(setMenuOpen(item.path));
  };

  const handleClick = (e: any) => {
    if (drawerOpen === false) {
      setshowPopOver(true);
      setAnchorEl(e.currentTarget);
    }
    if (item.children) {
      e.preventDefault();
      setMenuOpenState();
      return;
    }
    handleItemPath(item);
    dispatch(setMenuOpen(undefined));
  };

  const handlePopoverClose = () => {
    setshowPopOver(false);
    setAnchorEl(null);
  };

  return (
    <>
      <ListItem
        selected={
          location.pathname === item.path ||
          location.pathname.includes(item.path)
        }
        className={classes.root}
        button
        onClick={handleClick}
        onAuxClick={handleClick}
        onMouseEnter={(e) => {
          if (drawerOpen === false) {
            handleClick(e);
          }
        }}
      >
        {item.showBadge ? (
          <Badge
            color="secondary"
            overlap="circular"
            badgeContent=" "
            variant="dot"
            anchorOrigin={{
              horizontal: "left",
              vertical: "top",
            }}
          >
            <ListItemIcon className={classes.icon}>{item.icon}</ListItemIcon>
          </Badge>
        ) : (
          <ListItemIcon className={classes.icon}>{item.icon}</ListItemIcon>
        )}
        <ListItemText primary={item.title} />
        &nbsp;
        {item.children ? (
          showChildren ? (
            <IconChevronUp />
          ) : (
            <IconChevronDown />
          )
        ) : null}
      </ListItem>
      {drawerOpen === true && item.children ? (
        <Collapse in={showChildren} timeout="auto" unmountOnExit>
          <div className={classes.rootNested}>
            {item.children.map((child: any, index: number) => (
              <Link
                key={index}
                style={{ textDecoration: "none", color: "unset" }}
                to={child.path}
              >
                <div key={index} className="SubItem">
                  <ListItem
                    key={index}
                    selected={
                      localStorage.getItem("lastPath") === child.path ||
                      Boolean(menuSelected === child.path)
                    }
                    button
                    onClick={() => {
                      handleItemPath(child);
                    }}
                    onAuxClick={() => {
                      handleItemPath(child);
                    }}
                  >
                    <ListItemIcon className={classes.icon}>
                      <IconPointFilled size={12} />
                    </ListItemIcon>
                    <ListItemText>{child.title}</ListItemText>
                  </ListItem>
                </div>
              </Link>
            ))}
          </div>
        </Collapse>
      ) : null}
      {drawerOpen === false && item.children ? (
        <Popover
          id="mouse-over-popover"
          open={showPopOver}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus
        >
          <div>
            {item.children.map((child: any, index: number) => (
              <Link
                key={index}
                style={{ textDecoration: "none", color: "unset" }}
                to={child.path}
              >
                <div key={index} className="SubItem">
                  <ListItem
                    key={index}
                    selected={
                      localStorage.getItem("lastPath") === child.path ||
                      Boolean(menuSelected === child.path)
                    }
                    button
                    onClick={() => {
                      handleItemPath(child);
                    }}
                    onAuxClick={() => {
                      handleItemPath(child);
                    }}
                  >
                    <ListItemIcon className={classes.icon}>
                      <IconPointFilled size={12} />
                    </ListItemIcon>
                    <ListItemText>{child.title}</ListItemText>
                  </ListItem>
                </div>
              </Link>
            ))}
          </div>
        </Popover>
      ) : null}
    </>
  );
};

export const SideBarMenuItems = withRouter((pros) => {
  const { userInfo } = useAppSelector((state) => state.auth);
  const classes = useStyles();

  return (
    <List className={classes.root}>
      {screenRoutes
        .filter((screen) => screen.roles.includes(userInfo?.perfil!))
        .map((item, index) => {
          if (item.children) {
            return <MenuItem key={index} item={item} pros={pros} />;
          } else {
            return (
              <Link
                style={{ textDecoration: "none", color: "unset" }}
                key={index}
                to={item.path}
              >
                <MenuItem key={index} item={item} pros={pros} />
              </Link>
            );
          }
        })}
    </List>
  );
});
